//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";

// custom pages
import CollapsibleTable from "components/Table/CollapsibleTable";
import styles from "./styles";
import Loader from "components/Loader/Loader";
import Context from "context/context";

import LinearProgress from "@material-ui/core/LinearProgress";
import { useTranslation } from 'react-i18next';
export default function Redeemed(props) {
  const {
    data,
    offset,
    count,
    setOffset,
    currentTab,
    viewMore,
    setViewMore,
    viewMoreEnd,
    noData,
    response,
    loading,
  } = props;

  const classes = styles();
  const {t , i18n} = useTranslation()
  const { state, dispatch } = useContext(Context);

  // const callback = () => {
  //   if (offset[currentTab] !== 1) {
  //     if (viewMoreEnd[currentTab]?.length == 0) {
  //       setOffset({ ...offset, [currentTab]: offset[currentTab] + 1 });
  //     }
  //   }
  // };
  const handlePagination = (value) => {
    console.log(value,'this is the paginationvalues')
     setOffset({ ...offset, [currentTab]: value });
   };
  // const scrollRef = useBottomScrollListener(callback);
  const headings1 = [
    "Redemption Date",
    "Status",
    "Billing Account",
    "Shipto",
    "Rejected Reason",
    "Business Name",
    "Points Redeemed",
    "Credit Issued",
    state?.ALA?.["Loyalty_Account.loyalty_organization_name"] == "Henry Schein Dental" ? "Action" : null,
  ]
  const headings2 = [
    "Redemption Date",
    "Status",
    "Billing Account",
    "Shipto",
    "Reason",
    "Points Redeemed",
    "Credit Issued",
    state?.ALA?.["Loyalty_Account.loyalty_organization_name"] == "Henry Schein Dental" ? "Action" : null,
  ]
  return (
    <React.Fragment>
      {response ? (
        <div className="points-redeemed-table-wrapper">
          <div
            className={
              viewMore[currentTab] ? classes.tableDiv : classes.tableDiv2
            }
            id="redeemed"
            // ref={scrollRef}
          >
            <CollapsibleTable
              data={data}
              headings={currentTab === "redeemed" ?
                headings1.map(i => <div key={t(i)} className={classes.redeemedHeadings}>{t(i)}</div>)
                :
                headings2.map(i => <div  key={t(i)} className={classes.redeemedHeadings}>{t(i)}</div>)}
              subHeadings={[
                t("Order Number"),
                t("Line Number"),
                t("Product Description"),
                t("Purchase Value"),
                t("Points Redeemed"),
                t("Credit Issued"),
              ]}
              keys={currentTab === "redeemed" ? [
                "reedemption_date",
                "status",
                "customer_billto_account_number",
                "customer_account_number",
                "rejected_reason",
                "loyalty_organization_name",
                "points_redeemed",
                "credit_issued",
              ] : [
                "reedemption_date",
                "status",
                "customer_billto_account_number",
                "customer_account_number",
                "rejected_reason",
                "points_redeemed",
                "credit_issued",
              ]}
              subKeys={[
                "order_number",
                "line_number",
                "product_short_description",
                "purchase_value",
                "points_redeemed",
                "credit_issued",
              ]}
              offset={ offset[currentTab]}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
              collapsible={state?.ALA?.["Loyalty_Account.loyalty_organization_name"] == "Henry Schein Dental" ? true : false}
              sorting={true}
              sortingFields={{
                column: "Redemption Date",
                row: "reedemption_date",
              }}
              currentTab={currentTab}
              language={i18n.language}
             
            />
          </div>
          {/* {!noData[currentTab] && !viewMore[currentTab] && (
            <div
              className={classes.viewMore}
              style={{ fontSize: "1rem" }}
              onClick={() => {
                setViewMore({ ...viewMore, [currentTab]: true });
                setOffset({ ...offset, [currentTab]: offset[currentTab] + 1 });
              }}
            >
              <span className={classes.viewMoreText}>View More</span>
            </div>
          )} */}
        </div>
      ) : (
        <Loader Loading={!response} top={"15%"}></Loader>
      )}
      {viewMore[currentTab] && loading ? (
        <LinearProgress style={{ margin: "10px 0px", color: "#3891CB" }} />
      ) : null}
    </React.Fragment>
  );
}
